export type SessionHealthView = {
  health: "healthy" | "suspect" | "wedged";
  reason?: string | null;
  atMs: number;
};

export type TurnPhaseView = {
  clientRunId: string;
  from: string;
  to: string;
  atMs: number;
};

export type RunTimelineEntry = {
  id: string;
  kind: string;
  summary: string;
  detail?: string | null;
  atMs: number;
};

export type OperatorTrustSessionState = {
  sessionHealth?: SessionHealthView;
  turnPhase?: TurnPhaseView;
  timeline: RunTimelineEntry[];
};

export function emptyOperatorTrustState(): OperatorTrustSessionState {
  return { timeline: [] };
}

export function resolveOperatorTrustForSession(
  map: Record<string, OperatorTrustSessionState>,
  sessionKey: string,
): OperatorTrustSessionState {
  return map[sessionKey.trim()] ?? emptyOperatorTrustState();
}
